import { pathJoin } from '../../../../utils'
import { createRouteMapContainerGroupDetail } from './container-group-detail'

export const createRoutesMapContainerGroup = (prefix: string) => ({
  create: pathJoin(prefix)(`create`).chain,
  '/:id': (id: string) =>
    pathJoin(prefix)(id).chainMapAuto(createRouteMapContainerGroupDetail),
  'edit/:id': (id: string) => pathJoin(prefix)('edit')(id).chain,
})
